<template>
	<div class="main-contents hr">
		<div class="tit">
			IT프로 최종 정보
			<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="goList()"/>
			<img src="/images/admin/special_rank_btn.png" alt="스페셜등급관리" @click="special()"/>
			<img src="/images/admin/certi_btn.png" alt="기술인증서발급" @click="printTecCert"/>
		</div>
		<div class="member-name">
			<div class="tec-num">
				회원번호 <span class="num">{{data.tecSeq}}</span>
			</div>
		</div>

		<tecInfo v-model="data" type="admin" :tecMberSeq="tecMberSeq" :finalTec="finalTec" :possEditYn="possEditYn" ref="tecInfo" @click="clickTecInfo($event.type, $event.item)">
			<template v-slot:bottom>
				<div class="resume_detail_btn" v-if="!showResm">
					<img src="/images/admin/resume_detail_btn.png" alt="이력서 상세보기" @click="showResume()"/>
				</div>
			</template>
		</tecInfo>
		<project-brife :tecMberSeq="tecMberSeq"/>

		<div v-show="showResm">
			<!-- <div class="sub-tit" ref="resume"><hr><p>이력서 상세</p><hr></div> -->
			<div class="sub-tit" ref="resume"><p>이력서 상세</p></div>
			<tec-resume-view v-model="resume" :tecMberSeq="tecMberSeq" v-if="showResm || resume.regYn" @input="searchResm">
				<template v-slot:empty>
					<div class="dco_none">
						<p>등록하신 이력서가 없습니다.</p>
					</div>
				</template>
			</tec-resume-view>
		</div>
		<component v-show="!showResm" v-if="name != 'MEM912M02'" :key="name" :is="template" @searchEnd="searchEnd" ref="page" @move="move($event)"/>
		
		<!-- 기술회원 메모 -->
		<tec-memo :tecMberSeq="tecMberSeq"/>
	</div>
</template>

<script>
import tecInfo from "@/components/highpro/TecInfo.vue";
import tecMemo from "@/components/highpro/adm/TecMemo.vue";
import tecResumeView from "@/components/highpro/TecResumeView.vue";
import projectBrife from "@/components/highpro/TecInfo/TecInfoProjectBrife.vue";

export default {

	components : { tecInfo, tecResumeView, projectBrife, tecMemo },

	data() {
		return {
			tecMberSeq : this.$route.query.tecMberSeq,
			input:{},
			data: {},
			resume: { },
            resumeAttaFileDivCd: [],
            attaFileRelMap : {},
            attaFileRelEtcMap : {},
            attaFileRelEtcCount : 0,
			
			showResm: false,
			name: 'MEM912M02',
			histCnt  : 1,
			finalTec : this.$route.params.finalTec || 'N',
		};
	},
	watch: {
		$route(){
			//console.log('watch route', this.histCnt, this.$route.params.histCnt, this.$route);
			if(this.name != this.$route.name){
				//caller 경로가 이전 페이지 경로와 같으면 history +1 아니면 -1
				//if(this.name == (this.$route.params.caller||{}).name){
				//	this.histCnt ++;
				//} else {
				//	this.histCnt --;
				//}
				this.histCnt = this.$route.params.histCnt || 1;
				this.name = this.$route.name;
				
				if('MEM912M02,PRJ911M06'.indexOf(this.$route.name) > -1){
					this.showResm = true;
				} else {
					this.showResm = false;
				}
			}
		}
	},
	beforeMount(){
		//console.log('watch route beforeMount', this.histCnt, this.$route.params.histCnt, this.$route);
		this.histCnt = this.$route.params.histCnt || 1;
		if('MEM912M02,PRJ911M06'.indexOf(this.$route.name) > -1){
			this.showResm = true;
		} else {
			this.name = this.$route.name;
		}
	},
	methods: {
		goList(){
			//console.log('goList', this.histCnt, this.$route);
			this.$router.go(- this.histCnt)
		},
		move(info){
			var histCnt = this.histCnt + 1;
			if(typeof info == 'object'){
				info = info || {};
				info.params = info.params || {};
				info.params.histCnt = histCnt;
			} else if(typeof info == 'string'){
				info = { name: info, params: { histCnt }};
			}
			if(info.params.caller && info.params.caller.params){
				info.params.caller.params.histCnt = this.histCnt;
			}
			this.$router.push(info)
		},
        clickTecInfo(type, item){
			var nameDiv = this.$route.name.substring(0, 6) == 'PRJ911' ? '2' : '1';

			var tecMberSeq = this.tecMberSeq;
			var query = {tecMberSeq};
			var name = '';
			switch(type){
				case 'RESMVIEW'		: name = nameDiv == '1' ? 'MEM912M03' : 'PRJ911M07'; break;
				case 'INTREST'		: name = nameDiv == '1' ? 'MEM912M04' : 'PRJ911M08'; break;
				case 'POINT'		: name = nameDiv == '1' ? 'MEM912M06' : 'PRJ911M09'; break;
				case 'CLIENT_EVAL'	: name = nameDiv == '1' ? 'MEM912M07' : 'PRJ911M10'; break;
				case 'PRON_EVAL'	: name = nameDiv == '1' ? 'MEM912M08' : 'PRJ911M11'; break;
				case 'PROJ_NOW'		: name = nameDiv == '1' ? 'PRJ901M01' : 'PRJ911M12'; break;
				case 'PROJ_BEF'		: name = nameDiv == '1' ? 'PRJ903M01' : 'PRJ911M13'; break;
				case 'INTERVIEW'	: name = nameDiv == '1' ? 'PRJ904M01' : 'PRJ911M14'; break;
				case 'NCS'			: 
					name = nameDiv == '1' ? 'MEM912M05' : 'PRJ911M15';
					query.detailClassCd = item.detailClassCd;
					break;
			}

			if(name){
				this.showResm = false;
				this.input = query;
				var params = {
					histCnt : ++this.histCnt
				}

				var check = this.$route.name != name && Object.keys(query).length == Object.keys(this.$route.query).length;
				if(check == false){
					if('MEM912M05,PRJ911M15'.indexOf(this.$route.name) > -1 && this.$route.name != name) {
						check = true;
					}

					for(var key in query){
						if(query[key] != this.$route.query[key]){
							check = true;
							break;
						}
					}
				}

				if(check){
					this.$router.push({name, query, params})
				} else {
					this.searchEnd();
				}
			}
        },
		showResume(){
			this.showResm = true;
			if(this.resume.regYn){
				this.searchResm();
			}
		},
		searchResm(){
			if(this.name != 'MEM912M02'){
				this.$nextTick(() => {
					//console.log('searchResm', this.$refs.resume);
					window.scroll({top:this.$refs.resume.offsetTop, behavior: 'smooth'});
				});
			}
		},
		searchEnd(){//res
			this.$nextTick(() => {
				// console.log('searchEnd', this.$refs.page);
				window.scroll({top:this.$refs.page.$el.offsetTop, behavior: 'smooth'});
			});
		},
		special(){
			var tecMberSeq = this.tecMberSeq; 
			this.$.popup('/adm/mem/MEM912P01', { tecMberSeq })
				.then(res=> {
					if(res) this.$refs.tecInfo.search();
				});
		},
		printTecCert(){
			this.$.httpPost('/api/mem/adm/tec/setPrintTechCerti', {tecMberSeq : this.$route.query.tecMberSeq})
				.then(res => {
					//console.log('printTecCert RESULT', res);
					var url = "/REPORT?fileName=MEM910R02"
							+ "&issYyyy=" + res.data.issYyyy
							+ "&issSeq=" + res.data.issSeq
							+ "&verifyVal=" + res.data.verifyVal;

					window.open(url,"report","width=900,height=800, scrollbars=yes, resizable=yes");
				}).catch(this.$.httpErrorCommon);
		}

	},
	computed: {
		//프로젝트 참여설정은 회원관리(MEM912) 경로에서만 변경할 수 있다. (프로젝트관리(PRJ911) 경로에서는 조회만)
		possEditYn() {
			return this.$route.name.substring(0, 6) == 'PRJ911' ? 'N' : 'Y';
		},
		template() {
			if(!this.name || this.name == 'MEM912M02'){
				return 'div';
			} else {
				var tempName = '';

				switch(this.name){
					case 'PRJ911M07' : tempName = 'MEM912M03'; break;
					case 'PRJ911M08' : tempName = 'MEM912M04'; break;
					case 'PRJ911M09' : tempName = 'MEM912M06'; break;
					case 'PRJ911M10' : tempName = 'MEM912M07'; break;
					case 'PRJ911M11' : tempName = 'MEM912M08'; break;
					case 'PRJ911M12' : tempName = 'PRJ901M01'; break;
					case 'PRJ911M13' : tempName = 'PRJ903M01'; break;
					case 'PRJ911M14' : tempName = 'PRJ904M01'; break;
					case 'PRJ911M15' : tempName = 'MEM912M05'; break;
					default : tempName = this.name;
				}

				var path = tempName.substring(0, 3).toLowerCase();
				// console.log('template', path, this.name, tempName);
				return () => {
					return import('@/views/adm/' + path + '/' + tempName + '.vue')
						.catch(() => { 
							// console.log('PopupWrap', 'path', this.path);
							//console.error('PopupWrap', 'import path error', err);
						})
				};
			}
		},
	}
};
</script>
